var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgQualityHigh = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 26,
    viewBox: "0 0 41 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.4533 7.56873C35.9645 10.6962 33.2587 13.089 29.9941 13.089C26.7295 13.089 24.0238 10.6963 23.5349 7.56896H1.19063C0.628798 7.56896 0.17334 7.1135 0.17334 6.55166C0.17334 5.98983 0.628798 5.53437 1.19063 5.53437H23.5347C24.0231 2.40637 26.7291 0.013031 29.9941 0.013031C33.259 0.013031 35.965 2.40625 36.4534 5.53414L39.1527 5.53414C39.7146 5.53414 40.17 5.9896 40.17 6.55143C40.17 7.11327 39.7146 7.56873 39.1527 7.56873L36.4533 7.56873ZM34.4975 6.551C34.4975 9.03814 32.4812 11.0544 29.9941 11.0544C27.5069 11.0544 25.4907 9.03814 25.4907 6.551C25.4907 4.06385 27.5069 2.04762 29.9941 2.04762C32.4812 2.04762 34.4975 4.06385 34.4975 6.551Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1993 25.0794C13.4641 25.0794 16.17 22.6864 16.6586 19.5587L39.1529 19.5587C39.7148 19.5587 40.1702 19.1032 40.1702 18.5414C40.1702 17.9796 39.7148 17.5241 39.1529 17.5241L16.6586 17.5241C16.1699 14.3965 13.4641 12.0035 10.1993 12.0035C6.93428 12.0035 4.22826 14.3968 3.7399 17.5248H1.19063C0.628798 17.5248 0.17334 17.9803 0.17334 18.5421C0.17334 19.104 0.628798 19.5594 1.19063 19.5594H3.74011C4.22903 22.6868 6.93475 25.0794 10.1993 25.0794ZM10.1993 23.0448C12.6864 23.0448 14.7027 21.0286 14.7027 18.5415C14.7027 16.0543 12.6864 14.0381 10.1993 14.0381C7.71215 14.0381 5.69592 16.0543 5.69592 18.5415C5.69592 21.0286 7.71215 23.0448 10.1993 23.0448Z",
    fill: "white"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgQualityHigh);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/quality-high.beda6403b7bea9da51811a3cd32bdd6c.svg";